import React from 'react';
import PropTypes from 'prop-types';
import { Popup, Loader } from 'semantic-ui-react';
import { Paperclip as LinkIcon, ChevronDown } from 'common/images/FaIcons';
import { useTranslation } from 'react-i18next';
import {
  CouplingHeaderRow,
  HeaderLeft,
  ToggleSwitchTrack,
  ToggleSwitchThumb,
  ToggleSwitchLabel,
  ToggleSwitchWrapper,
  LoadingIndicator,
  LoadingText,
  LinkedBadge,
  CollapseButton
} from './styled';

const CouplingHeader = ({
  enabled,
  isExpanded,
  fetchingAlarms,
  isUpdatingConditions,
  onToggle,
  onToggleExpand,
  statusTooltip
}) => {
  const { t } = useTranslation();

  return (
    <CouplingHeaderRow isExpanded={isExpanded}>
      <HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ToggleSwitchWrapper onClick={onToggle} disabled={fetchingAlarms}>
            <ToggleSwitchTrack checked={enabled}>
              <ToggleSwitchThumb checked={enabled} />
            </ToggleSwitchTrack>
            <ToggleSwitchLabel checked={enabled}>
              {t('sensors.eventDetection.coupling.coupleWithAlarmThresholds')}
            </ToggleSwitchLabel>
          </ToggleSwitchWrapper>
          {statusTooltip}
        </div>
        {fetchingAlarms && (
          <LoadingIndicator>
            <Loader active inline size="tiny" />
            <LoadingText>{t('sensors.eventDetection.coupling.loadingThresholds')}</LoadingText>
          </LoadingIndicator>
        )}
        {isUpdatingConditions && !fetchingAlarms && (
          <LoadingIndicator>
            <Loader active inline size="tiny" />
            <LoadingText>{t('sensors.eventDetection.coupling.updatingConditions')}</LoadingText>
          </LoadingIndicator>
        )}
        <Popup
          trigger={(
            <LinkedBadge>
              <LinkIcon />
              <span>{t('sensors.eventDetection.coupling.linked')}</span>
            </LinkedBadge>
          )}
          content={t('sensors.eventDetection.coupling.linkedHelp')}
          position="bottom right"
          size="small"
        />
      </HeaderLeft>
      <CollapseButton
        onClick={onToggleExpand}
        isExpanded={isExpanded}
        type="button"
      >
        {isExpanded ? t('sensors.eventDetection.coupling.collapse') : t('sensors.eventDetection.coupling.expand')}
        <ChevronDown />
      </CollapseButton>
    </CouplingHeaderRow>
  );
};

CouplingHeader.propTypes = {
  enabled: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  fetchingAlarms: PropTypes.bool,
  isUpdatingConditions: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onToggleExpand: PropTypes.func.isRequired,
  statusTooltip: PropTypes.node
};

CouplingHeader.defaultProps = {
  fetchingAlarms: false,
  isUpdatingConditions: false,
  statusTooltip: null
};

// Memoized because props are stable (primitives and useCallback functions)
export default React.memo(CouplingHeader);
